import { inject, injectable } from 'inversify'

import { InjectionTokens } from '@/controller/tokens'

import { Result } from '@/domain/protocols/Result'

import { IProceduresRepository, RequestGetProceduresResponse } from './IProceduresRepository'

import type { IHttpClient } from '@/infra/http/IHttpClient'
@injectable()
export class ProceduresRepository implements IProceduresRepository {
  constructor(@inject(InjectionTokens.HttpClient) private httpCLient: IHttpClient) {}

  getBaseUrl(): string {
    return 'https://nexatlas-static-files.nyc3.digitaloceanspaces.com/procedures'
  }

  async getProcedureCharts(icao: string): Promise<Result<RequestGetProceduresResponse>> {
    try {
      const response = await this.httpCLient.get<RequestGetProceduresResponse>(
        `${this.getBaseUrl()}/${icao}/manifest.json`,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.success === false) return Result.fail(response.error)

      // Aeródromos sem cartas não possuem manifest.json: o Spaces responde 403 (AccessDenied,
      // sem permissão de listagem) ou 404. Isso é "sem cartas", não um erro real.
      if (response.status === 403 || response.status === 404) return Result.ok([])

      // Demais não-200 (5xx, etc.) são falhas reais de servidor.
      if (response.status !== 200) return Result.fail(response.response)

      // 200 com payload inesperado (não-array) degrada para "sem cartas".
      if (!Array.isArray(response.response)) return Result.ok([])

      return Result.ok(response.response)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
